(function (angular) {
	'use strict';

	angular
		.module('orderFormModule')
		.factory('orderFormFactory', [
			'urlFactory',
			orderFormFunction
		]);

	function orderFormFunction(
		urlFactory) {
		
		var factory = {
			submitOrderForm: submitOrderForm
		};

		return factory;
		
		function submitOrderForm(planId, serviceLevel) {
			var orderForm = {
				riaPlanId: planId,
				serviceLevel: serviceLevel
			};

			return urlFactory.postPromise('/ria/add-order-form-to-session.json', orderForm);
		}
	}
})(window.angular);